// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2qB8t","approved":"Status_approved__31WKC","rejected":"Status_rejected__23bhS","expired":"Status_expired__2fFci","label":"Status_label__3IMwq"};